<template>
    <div class="m_container">
        <Header :title="tougaoInfo.title" />
        <section class="m_section">
            <div class="list">
                <div class="theader">
                    <p class="lis">{{ $t('my.name') }}</p>
                    <p class="lis">{{ $t('my.category') }}</p>
                    <p class="lis">{{ $t('my.ticket') }}</p>
                    <p class="lis">{{ $t('my.status') }}</p>
                    <p class="lis opera">{{ $t('my.operate') }}</p>
                </div>
                <div v-for="(item, index) in list" :key="index" class="theader tbody">
                    <p class="lis">{{ item.title }}</p>
                    <p class="lis">{{ item.category }}</p>
                    <p class="lis">{{ item.ticket }}</p>
                    <p class="lis">{{ item.status_name }}</p>
                    <div class="lis opera">
                        <p v-if="!item.ticket" class="edit" @click="handleUpdate(item)">
                            {{ $t('my.edit') }}
                        </p>
                        <p v-if="!item.ticket" class="confirm" @click="confirmTouGao(item, '1')">
                            {{ $t('my.confirm') }}
                        </p>
                        <p v-if="item.ticket" class="confirm" @click="confirmTouGao(item, '0')">
                            {{ $t('my.view') }}
                        </p>
                        <!-- v-if="item.ticket" -->
                        <p v-if="item.status === 40 || item.status === 50 || item.status === 90" class="confirm" @click="confirmTouGao(item, '3')">
                            {{ $t('my.receipt') }}
                        </p>
                    </div>
                </div>
            </div>
            <el-button v-if="showLogout" type="info" class="submitBtn" @click="logout">
                {{ $t('my.logout') }}
            </el-button>
        </section>
        <TabBar :current-tab="currentTab" />
        <div class="fix_box">
            <LangSelect class="lang" />
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import LangSelect from '@/components/LangSelect'
import { mapGetters } from 'vuex'
import { getTid, setTid } from '@/utils/cookies'
import { zuopinList } from '@/api/Tougaos'

export default {
    name: 'My',
    components: { Header, TabBar, LangSelect },
    data() {
        return {
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            currentTab: 'my',
            listQuery: {
                tid: this.$route.query.tid ? this.$route.query.tid : getTid()
            },
            list: [],
            loading: false,
            showLogout: !!this.$store.getters.token
        }
    },

    computed: {
        ...mapGetters(['tougaoInfo'])
    },

    created() {
        this.tid ? setTid(this.tid) : ''
        this.$store.getters.token ? this.getList() : this.toLogin()
    },

    methods: {
        toLogin() {
            this.$alert('请先登录', '提示', {
                confirmButtonText: '确定',
                callback: (action) => {
                    this.$router.push({ path: '/login', query: { tid: this.tid } })
                }
            })
        },

        getList() {
            this.loading = true
            zuopinList(this.listQuery)
                .then((res) => {
                    if (res.code === 200) {
                        this.list = res.data.list
                        this.loading = false
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },

        handleUpdate(item) {
            if (item.ticket) {
                this.$message({
                    message: '已确认状态,不可再修改',
                    type: 'warning',
                    showClose: true,
                    duration: 2000
                })
                return
            }
            this.$router.push({
                path: '/tougao',
                query: { tid: this.tid, zpid: item.id, isEdit: 1 }
            })
        },

        confirmTouGao(item, type) {
            // this.$router.push({
            //     path: '/confirmTouGao',
            //     query: { tid: this.tid, zpid: item.id, issubmit: type }
            // })
            const { tid } = this
            const isNewPage = String(tid) === '29' || tid === '34' || tid === '50' || tid === '51'
            this.$router.push({
                path: isNewPage && type === '3' ? '/confirm_new' : 'confirmTouGao',
                query: { tid: this.tid, zpid: item.id, issubmit: type }
            })
        },

        logout() {
            this.$confirm('确定退出?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('user/logout').then(() => {
                    if (this.tid) {
                        this.$router.push({ path: '/homeTougao', query: { tid: this.tid } })
                    }
                    if (this.sid) {
                        this.$router.push({ path: '/homeExam', query: { sid: this.sid } })
                    }
                })
            })
        }
    }
}
</script>

<style lang="less" scoped>
.m_container {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .m_section {
        flex: 1;
        padding-bottom: 100px;
        z-index: 8;

        .list {
            color: #999;
            line-height: 38px;
            padding: 0;
            font-size: 13px;
            background: #fff;
            margin: 10px 10px;
        }

        .theader {
            // padding:10px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid #f6f6f6;

            .lis {
                flex: 2;
                padding: 0 8px;
                text-align: center;
                font-size: 16px;
                color: var(--bck);
                font-weight: bold;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .opera {
                margin-left: 8px;
                padding: 4px 10px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                p {
                    margin-block-start: 0;
                    margin-block-end: 0;
                    line-height: 28px;
                }

                .confirm_gray {
                    color: #999;
                }
            }
        }

        .tbody {
            .lis {
                color: #999;
                font-size: 12px;
                font-weight: normal;
                line-height: 38px;
            }
            .opera {
                color: var(--color);
                justify-content: space-between;
            }

            .opera_center {
                justify-content: center;
            }
        }

        .submitBtn {
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            bottom: 60px;
            width: 90%;
        }
    }
}

.fix_box {
    position: fixed;
    bottom: 120px;
    right: 10px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f5f5f5;
    z-index: 9;
}
</style>
